module.exports = __webpack_public_path__ + "static/media/readocente.5a5f7ae3.png";